import { Box } from '@mindfulchefuk/design-system'
import { motion, useScroll, useTransform } from 'motion/react'
import React, { ReactChild, useRef } from 'react'
import { useIsOverflowing } from './hooks/useIsOverflowing'

export const RecipeModalScrollArea = ({
  children,
}: {
  children?: ReactChild[]
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({ container: ref })
  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0])
  const isOverflowing = useIsOverflowing(ref)

  return (
    <Box position="relative">
      <Box
        overflowY="auto"
        height="100%"
        maxHeight={['none', '700px']}
        ref={ref}
        pr={24}
        pl={24}
        pt={[0, 24]}
        pb={['72px', 32]} // Gives space for the fixed CTA on mobile
      >
        {isOverflowing && (
          <motion.div style={{ opacity }} data-testid="recipe-modal-gradient">
            <Box
              display={['none', 'block']}
              height={112}
              position="absolute"
              left={0}
              right={0}
              bottom={0}
              z={2}
              pointerEvents="none"
              backgroundImage="linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 100%) 100%)"
            />
          </motion.div>
        )}

        {children}
      </Box>
    </Box>
  )
}
